import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import * as React from 'react';
import { RootStyles, ViewportStyles, ScrollAreaScrollbarStyles, ScrollAreaThumbStyles } from './styles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const ScrollArea = React.forwardRef(({
  children,
  height = 'auto',
  width = 'auto',
  ...props
}, ref) => jsx(RootStyles, {
  ref: ref,
  height: height,
  width: width,
  type: "auto",
  ...props,
  children: jsxs(ViewportStyles, {
    children: [children, jsx(ScrollBar, {}), jsx(ScrollAreaPrimitive.Corner, {})]
  })
}));
const ScrollBar = React.forwardRef(({
  orientation = 'vertical',
  ...props
}, ref) => {
  return jsx(ScrollAreaScrollbarStyles, {
    ref: ref,
    orientation: orientation,
    ...props,
    children: jsx(ScrollAreaThumbStyles, {})
  });
});

export { ScrollArea };
